import * as React from "react";

import {
  Box,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Tfoot,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import {
  ColumnDef,
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { ISelectOption } from "../../components/forms/SelectControl";

export interface IProps {
  columns: ISelectOption[];
  data: { [key: string]: string }[];
}

const columnHelper = createColumnHelper<any>();
// const columnHelper = createColumnHelper<Person>();

export const EncryptTable = ({ columns, data }: IProps) => {
  const [tableColumns, setTableColumns] = React.useState<ColumnDef<any>[]>([]);

  const table = useReactTable({
    data,
    columns: tableColumns,
    getCoreRowModel: getCoreRowModel(),
  });

  const buildColumns = () => {
    const updateColumns = columns.map((col) => {
      return columnHelper.accessor(col.value, {
        header: () => col.label,
        // footer: (props) => props.column.id,
      });
    });

    setTableColumns(updateColumns);
  };

  React.useEffect(() => {
    buildColumns();
  }, [columns]);

  return (
    <Stack>
      <Box maxW="full" flex={1} overflowX={"scroll"} overflowY="hidden">
        <Table borderWidth="1px" rounded="lg">
          <Thead bg="bg.high" borderBottomWidth={1}>
            {table.getHeaderGroups().map((headerGroup) => (
              <Tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <Th key={header.id} color="text" fontSize="lg">
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody>
            {table.getRowModel().rows.map((row) => (
              <Tr key={row.id}>
                {row.getVisibleCells().map((cell) => (
                  <Td key={cell.id}>
                    <Text noOfLines={2}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </Text>
                  </Td>
                ))}
              </Tr>
            ))}
          </Tbody>
          <Tfoot>
            {table.getFooterGroups().map((footerGroup) => (
              <Tr key={footerGroup.id}>
                {footerGroup.headers.map((header) => (
                  <Th key={header.id}>
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.footer,
                          header.getContext()
                        )}
                  </Th>
                ))}
              </Tr>
            ))}
          </Tfoot>
        </Table>
      </Box>
    </Stack>
  );
};
